import React, { useState } from "react";
import "./StaticPage.css";
import "./Contact.css";

var BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:4000";

export default function Contact() {
  var [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  var [status, setStatus] = useState("");
  var [sending, setSending] = useState(false);
  var [errors, setErrors] = useState({});

  function validate() {
    var errs = {};
    if (!form.name.trim()) errs.name = 'Please enter your name.';
    var emailOk = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email);
    if (!emailOk) errs.email = 'Please enter a valid email address.';
    if (!form.subject.trim()) errs.subject = 'Please enter a subject.';
    if (!form.message.trim()) errs.message = 'Please enter a message.';
    return errs;
  }

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: null });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    var errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    setSending(true);
    setStatus("");
    try {
      var res = await fetch(BACKEND_URL + "/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (res.ok) {
        setStatus("success");
        setForm({ name: "", email: "", subject: "", message: "" });
      } else {
        setStatus("error");
      }
    } catch (err) {
      setStatus("error");
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="static-page">
      <div className="contact-container">
        <div className="contact-header">
          <span className="section-label">Get in Touch</span>
          <h1>We'd love to hear from you</h1>
          <p className="static-intro">
            Questions about our products, your order, or just want to say namaste?
            Reach out — we usually reply within 24 hours.
          </p>
        </div>

        <div className="contact-grid">
          {/* Contact info cards */}
          <div className="contact-info">
            <div className="contact-info-card">
              <div className="contact-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              </div>
              <div>
                <h3>Email Us</h3>
                <a href="mailto:wecare@purejar.in">wecare@purejar.in</a>
                <a href="mailto:orders@purejar.in">orders@purejar.in</a>
              </div>
            </div>

            <div className="contact-info-card">
              <div className="contact-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/></svg>
              </div>
              <div>
                <h3>WhatsApp</h3>
                <a href="https://wa.me/918750128338" target="_blank" rel="noopener noreferrer">+91 87501 28338</a>
                <span className="contact-hours">Mon–Sat, 10 AM – 6 PM</span>
              </div>
            </div>

            <div className="contact-info-card">
              <div className="contact-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
              </div>
              <div>
                <h3>Visit Us</h3>
                <p className="contact-address">Rampur Road, Dewalchaur,<br/>Haldwani, Nainital,<br/>Uttarakhand — 263139</p>
              </div>
            </div>
          </div>

          {/* Contact form */}
          <div className="contact-form-wrap">
            {status === "success" ? (
              <div className="contact-success">
                <div className="contact-success-icon">✓</div>
                <h3>Message sent!</h3>
                <p>Thank you for reaching out. We'll get back to you within 24 hours.</p>
                <button className="btn-primary" onClick={function() { setStatus(""); }}>Send Another</button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label>Your Name</label>
                  <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="Full name" />
                  {errors.name && <span className="field-error">{errors.name}</span>}
                </div>
                <div className="form-group">
                  <label>Email Address</label>
                  <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="you@example.com" />
                  {errors.email && <span className="field-error">{errors.email}</span>}
                </div>
                <div className="form-group">
                  <label>Subject</label>
                  <input type="text" name="subject" value={form.subject} onChange={handleChange} placeholder="What's this about?" />
                  {errors.subject && <span className="field-error">{errors.subject}</span>}
                </div>
                <div className="form-group">
                  <label>Message</label>
                  <textarea name="message" value={form.message} onChange={handleChange} placeholder="Tell us how we can help..." rows="5"></textarea>
                  {errors.message && <span className="field-error">{errors.message}</span>}
                </div>
                {status === "error" && <p className="contact-error">Something went wrong. Please try again or email us directly.</p>}
                <button type="submit" className="btn-primary" disabled={sending}>
                  {sending ? "Sending..." : "Send Message"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
